import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@nexus/ui";
import { useTranslation } from "react-i18next";

import { truncateSetName } from "@/features/opportunities/lib/format-opportunity.js";

export interface DeletePersonaOpportunitySetDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  setName: string;
  onConfirm: () => void;
  isDeleting?: boolean;
}

export function DeletePersonaOpportunitySetDialog({
  open,
  onOpenChange,
  setName,
  onConfirm,
  isDeleting,
}: DeletePersonaOpportunitySetDialogProps) {
  const { t } = useTranslation();
  const displayName = truncateSetName(setName);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            {t("personaOpportunities.deleteSet.title", "Remove set")}
          </DialogTitle>
          <DialogDescription>
            {t("personaOpportunities.deleteSet.description", {
              name: displayName,
              defaultValue: `Are you sure you want to remove "${displayName}"? All opportunities in this set will also be removed.`,
            })}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            type="button"
            variant="ghost"
            onClick={() => onOpenChange(false)}
            disabled={isDeleting}
          >
            {t("common.cancel", "Cancel")}
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting
              ? t("common.removing", "Removing…")
              : t("common.remove", "Remove")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
